// extracted by mini-css-extract-plugin
export default {"auth__forgot":"auth_auth__forgot__fjbwQ","auth__switch":"auth_auth__switch__apcIX"};